var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0875 3.75566L17.8405 0.951755C18.7535 -0.508318 21.051 0.311716 20.7935 2.00623L20.299 5.25939C20.1225 6.42078 21.258 7.35558 22.3935 6.98332L25.574 5.94062C27.2305 5.3977 28.453 7.47476 27.1455 8.61015L24.635 10.7902C23.739 11.5686 23.996 13.0007 25.11 13.4313L28.2295 14.6378C29.854 15.2661 29.4295 17.6281 27.684 17.6737L24.332 17.761C23.1355 17.7919 22.394 19.0514 22.965 20.0838L24.564 22.975C25.397 24.4807 23.5235 26.0226 22.1565 24.9564L19.5315 22.9097C18.5945 22.179 17.2015 22.6763 16.9625 23.8269L16.293 27.0496C15.9445 28.728 13.499 28.728 13.1505 27.0496L12.481 23.8269C12.242 22.6763 10.849 22.179 9.91205 22.9097L7.28705 24.9564C5.92005 26.0221 4.04705 24.4807 4.87955 22.975L6.47855 20.0838C7.04955 19.0519 6.30805 17.7924 5.11155 17.761L1.75955 17.6737C0.0135547 17.6281 -0.410945 15.2661 1.21405 14.6378L4.33355 13.4313C5.44705 13.0007 5.70455 11.5686 4.80855 10.7902L2.29805 8.61015C0.990554 7.47476 2.21305 5.3977 3.86955 5.94062L7.05005 6.98332C8.18505 7.35558 9.32105 6.42078 9.14455 5.25939L8.65005 2.00623C8.39255 0.311716 10.69 -0.508318 11.603 0.951755L13.356 3.75566C13.9815 4.75668 15.4645 4.75668 16.09 3.75566H16.0875Z",
    fill: "#FFAFAB",
    stroke: "#1C173A",
    strokeWidth: 0.392047,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedStar);
export default __webpack_public_path__ + "static/media/rounded_star.9a8d6dfa091cf3881bcfaad827b35fa0.svg";
export { ForwardRef as ReactComponent };